<script>
import Loading from '@/components/Loading.vue'

export default {
  name: 'FlowChip',
  components: { Loading },
  props: {
    value: {},
    config: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      styleFull: {
        backgroundColor: 'red',
      },
      styleAlpha: {
        backgroundColor: 'rgba(255, 0, 0, 0.2)',
      },
    }
  },
  watch: {
    value() {
      this.loadStyles()
    },
  },
  beforeMount() {
    this.loadStyles()
  },
  methods: {
    loadStyles() {
      this.styleAlpha = this.getStyle(0.15)
      this.styleFull = this.getStyle(1)
    },
    getStyle(alpha) {
      const hexColor = this.config[this.value].color

      const r = parseInt(hexColor.substring(1, 3), 16)
      const g = parseInt(hexColor.substring(3, 5), 16)
      const b = parseInt(hexColor.substring(5, 7), 16)

      return {
        backgroundColor: `rgba(${r}, ${g}, ${b}, ${alpha})`,
      }
    },
  },
}
</script>

<template>
  <div>
    <div v-if="!config[value]" class="rounded">
      <md-progress-spinner
        :md-diameter="16"
        :md-stroke="2"
        md-mode="indeterminate"
      />
    </div>

    <div
      v-else
      :id="value"
      :key="value"
      class="show-status"
      :style="styleAlpha"
    >
      <div class="inner-ball" :style="styleFull" />
      {{ config[value].label }}
    </div>
  </div>
</template>

<style scoped lang="scss">
.inner-ball {
  min-width: 10px;
  min-height: 10px;
  margin: 0 4px 0 4px;
  border-radius: 50%;
}

.show-status {
  display: flex;
  justify-content: center;
  align-items: center;
  color: #4d4d4d;
  font-weight: bold;
  padding: 4px 8px 4px 8px;
  border-radius: 16px;
  font-size: 12px;
  text-transform: uppercase;
  width: 100%;
  height: 100%;
}
</style>
